import React from 'react';
import { Link } from 'react-router-dom';

export function SeoBreadcrumbs({ currentLabel }) {
  return (
    <nav aria-label="Breadcrumb" style={{ marginBottom: '14px', fontSize: '0.92rem', color: '#b9bfcc' }}>
      <Link to="/" style={{ color: '#b9bfcc', textDecoration: 'none' }}>首页</Link>
      <span style={{ margin: '0 8px' }}>/</span>
      <span style={{ color: '#efa765' }}>{currentLabel}</span>
    </nav>
  );
}

export function SeoCompareTable({ title, rows }) {
  return (
    <section style={{ marginTop: '20px', marginBottom: '16px' }}>
      <h2>{title}</h2>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', background: '#232533', borderRadius: '10px', overflow: 'hidden' }}>
          <thead>
            <tr>
              <th style={thStyle}>维度</th>
              <th style={thStyle}>建议做法</th>
              <th style={thStyle}>常见误区</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i}>
                <td style={tdStyle}>{r.metric}</td>
                <td style={tdStyle}>{r.good}</td>
                <td style={tdStyle}>{r.bad}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export function SeoRelatedLinks({ links }) {
  return (
    <section style={{ marginTop: '18px' }}>
      <h2>相关文章与入口</h2>
      <ul style={{ paddingLeft: '20px' }}>
        {links.map((item, idx) => (
          <li key={idx} style={{ marginBottom: '6px' }}>
            <Link to={item.to} style={{ color: '#efa765' }}>{item.text}</Link>
          </li>
        ))}
      </ul>
    </section>
  );
}

const thStyle = {
  textAlign: 'left',
  borderBottom: '1px solid #3b3f52',
  padding: '10px',
  color: '#efa765',
  background: '#202334'
};

const tdStyle = {
  borderBottom: '1px solid #34384b',
  padding: '10px',
  color: '#d2d6e0',
  verticalAlign: 'top'
};
